/**
 * Valores do dropdown de status da listagem de Banner.
 *
 * `All` é uma sentinela de UI: o `SelectInput` do ADS precisa de um `value`
 * string para exibir "Todos" selecionado, então o "sem filtro" não pode ser
 * `undefined` no estado. A tradução para o query param `active` acontece em
 * `useBannerList` (`All` → parâmetro omitido).
 */
export const BANNER_STATUS_FILTER = {
  All: 'all',
  Active: 'active',
  Inactive: 'inactive',
} as const;

/** Status selecionável no filtro da listagem de Banner. */
export type BannerStatusFilter = (typeof BANNER_STATUS_FILTER)[keyof typeof BANNER_STATUS_FILTER];

/** Filtros (server-side) da listagem de Banner. */
export interface BannerFilters {
  /** Busca por título — vai para o query param `title`. */
  readonly search: string;
  /** Status do banner — vira `active: boolean` ou parâmetro omitido. */
  readonly status: BannerStatusFilter;
  /** ID da empresa selecionada; `undefined` quando nenhuma. */
  readonly companyId: number | undefined;
  /** Página atual (1-indexed). */
  readonly page: number;
}

/** Estado inicial dos filtros: nenhum filtro aplicado, primeira página. */
export const INITIAL_BANNER_FILTERS: BannerFilters = {
  search: '',
  status: BANNER_STATUS_FILTER.All,
  companyId: undefined,
  page: 1,
};
